<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <button-add @click="toAddPage" v-if="permissionCodes.indexOf('014001001') !== -1"/>
      </div>
      <div style="display: flex;justify-content: space-between;">
        <input-search placeholder="收费项名称" @search="searchKey" />
      </div>
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" @goToModifyPage="goToModifyPage" @deleteLine="deleteLine" deleteTipInfo="是否确认删除该缴费项？" :operationArr="operationArr" :cathUrl="uploadUrl" :onSuccess="uploadSuccess" />
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/CustomPayment";
import { bus } from "../../../utils/bus";
import { errorHandler } from "../../../utils/errorHandler";
import ButtonAdd from "../../../components/common/buttons/button-add";
import { nSuccess } from "../../../utils/notice";

export default {
  components: {
    ButtonAdd,
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    Breadcrumb
  },
  name: "pay-record",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "智慧收费",
          name: "charge-items-management"
        },
        {
          value: "收费项管理"
        }
      ],
      exportUrl: "",
      // addPageName: "charge-items-management-add",
      tableHead: [
        {
          prop: "chargeType",
          label: "收费类型"
        },
        {
          prop: "name",
          label: "收费项名称"
        },
        {
          prop: "chargeMode",
          label: "收费模式"
        },
        {
          prop: "type",
          label: "凭证类型"
        },
        {
          prop: "introduction",
          label: "收费规则说明"
        }
      ],
      operationArr: ["modify", "delete"],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      uploadUrl: "",
      selectionArr: [],
      requestData: {
        searchKey: ""
      }
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.uploadUrl = api.importPaymentItemBill;
    this.getPage();
  },
  activated() {
    this.getPage();
  },
  methods: {
    toAddPage() {
      this.$router.push({
        name: "charge-items-management-add"
      });
    },
    uploadSuccess(data) {
      const e = errorHandler("导入失败")(data);
      if (!(e instanceof Error)) {
        nSuccess("导入成功");
      }
    },
    goToModifyPage(code) {
      this.$router.push({
        path: "/charge_items_management_modify/" + code
      });
    },
    getPage() {
      let reqData = this.requestData;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;
      this.$axios
        .post(api.getPaymentItemPage, reqData)
        .then(res => {
          if (res.data.retCode === 1) {
            console.log(res);
            let data = res.data.data.list;
            this.total = res.data.data.total;
            this.tableData = data;
          }
        })
        .catch(errorHandler("获取信息失败"));
    },
    search(v) {
      this.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    searchKey(v) {
      this.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr;
    },
    deleteLine(code) {
      let codeStr = code.join("");
      this.$axios
        .post(api.deletePaymentItemByCodes, {
          code: codeStr
        })
        .then(res => {
          nSuccess("删除成功");
          this.getPage();
        })
        .catch(errorHandler("删除失败"));
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.el-input--small .el-input__inner {
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/CustomPayment/ChargeItemsManagement/ChargeItemsManagement.vue